import axios from 'axios';
import {
  FETCH_LIST, COMPANY_INFO, ALL_COMPANIES_LIST, COMPANY_WALL_POSTS,
} from './types';
import api from '../../../utils/api';

export default {
  async fetchList({ commit }, email) {
    const response = await axios(api.companies.fetch(email));
    commit(FETCH_LIST, { companies: response.data.results });
  },
  async fetchCompanyInfo(_, companyUrl) {
    const res = await axios(api.companies.fetchInfo(companyUrl));
    return res.data;
  },
  async fetchCompany(_, companyId) {
    const res = await axios(api.companies.fetchCompany(companyId));
    return res.data;
  },
  async editCompanyInfo({ commit }, editData) {
    const { data } = await axios(api.companies.editCompanyInfo(editData));
    commit(COMPANY_INFO, { companyInfo: data });
  },
  async fetchAllCompanies({ commit }) {
    const { data } = await axios(api.companies.fetchAllCompanies());
    commit(ALL_COMPANIES_LIST, {
      allCompaniesList: data.results,
      companiesCount: data.count,
      companiesNextPage: !!data.next,
    });
  },
  async searchCompanyByName(_, searchData) {
    const { data } = await axios(api.companies.searchCompanyByName(searchData));
    return data;
  },
  async fetchCompanyPublicInfo({}, id) {
    const { data } = await axios(api.companies.fetchCompanyPublicInfo(id));
    return data;
  },
  async searchCompanyNetworkUser({}, searchInfo) {
    const { data } = await axios(
      api.companies.searchCompanyNetworkUser(searchInfo),
    );
    return data;
  },
  async followUnfollowCompany({}, followdata) {
    const { data } = await axios(
      api.companies.followUnfollowCompany(followdata),
    );
    return data;
  },
  async fetchCompaniesList(_, page) {
    const { data } = await axios(api.companies.fetchCompaniesList(page));
    return data;
  },
  async registerCompany(_, companyData) {
    const response = await axios(api.companies.registerCompany(companyData));
    return response;
  },
  async searchOnCompaniesList(_, name) {
    const { data } = await axios(api.companies.searchOnCompaniesList(name));
    return data.results;
  },
  async removeEmployee(_, employeeData) {
    const { data } = await axios(api.companies.removeEmployee(employeeData));
    return data;
  },
  async changeCompany(_, companyData) {
    const { data } = await axios(api.companies.changeCompany(companyData));
    return data;
  },
  async addRemoveAdmin(_, adminData) {
    const { data } = await axios(api.companies.addRemoveAdmin(adminData));
    return data;
  },
  async addBillingAddress(_, addressData) {
    const { data } = await axios(api.companies.addBillingAddress(addressData));
    return data;
  },
  async updateBillingAddress(_, updateData) {
    const { data } = await axios(api.companies.updateBillingAddress(updateData));
    return data;
  },
  async deleteBillingAddress(_, billingId) {
    const { data } = await axios(api.companies.deleteBillingAddress(billingId));
    return data;
  },
  async fetchPaymentEntities() {
    const { data } = await axios(api.companies.fetchPaymentEntities());
    return data;
  },
  async fetchAdjustmentsWithId({}, invoiceId) {
    const { data } = await axios(api.companies.fetchAdjustmentsWithId(invoiceId));
    return data.results;
  },
  async fetchBillingAddress({}, id) {
    const { data } = await axios(api.companies.fetchBillingAddress(id));
    return data;
  },
  async companyWall({ commit }, wallQuery) {
    const { data } = await axios(api.companies.companyWall(wallQuery));
    commit(COMPANY_WALL_POSTS, { companyWall: data.results, page: wallQuery.page });
    return data;
  },
};
